/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, date: NonNullable<unknown> }} Case_Section_Reviewed_ByInputs */

const en_case_section_reviewed_by = /** @type {(inputs: Case_Section_Reviewed_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reviewed by ${i?.name} — ${i?.date}`)
};

const pt_br2_case_section_reviewed_by = /** @type {(inputs: Case_Section_Reviewed_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revisado por ${i?.name} — ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Reviewed by {name} — {date}" |
*
* @param {Case_Section_Reviewed_ByInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_reviewed_by = /** @type {((inputs: Case_Section_Reviewed_ByInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Reviewed_ByInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_reviewed_by(inputs)
	return pt_br2_case_section_reviewed_by(inputs)
});